<template>
  <div style="background-color: #fff;">
    <div ref="contentbox" class="scrollwrap">
      <div class="header"></div>
      <div class="main">
        <ul>
          <li v-for="item in dataList" :key="item.Art_Id" @click="jumpmore(item.Art_Code)">
            <p class="main_title">{{ item.Art_Title }}</p>
            <p class="main_content">{{ item.Art_Guidance }}</p>
            <!-- <p class="main_more" @click="jumpmore(item.Art_Code)">查看更多></p> -->
            <div class="main_info">
              <p class="main_date">{{ item.Art_Showtime.slice(0, 10) }}</p>
              <p class="main_people">
                <span class="main_reader">{{ item.Clicks }}阅</span>
                <span>{{ item.Comments }}评</span>
              </p>
            </div>
          </li>
        </ul>
        <p class="clickmore" v-if="isshow" @click="loadingmore">点击加载更多</p>
        <p class="clickmore" v-if="isall" @click="loadingmore">已加载全部内容</p>
      </div>
    </div>

    <Header v-if="showHead==0" />
  </div>
</template>
<script>
import Header from "../../components/Header";
import jsonp from "jsonp";
export default {
  name: "introduce",
  components: {
    Header
  },
  data() {
    return {
      dataList: [],
      page: 1,
      isshow: false,
      isall: false,
      miniToken: "",
      showHead:0
    };
  },
  mounted() {
    // if (/(MicroMessenger)/i.test(navigator.userAgent)) {
    //   const confirmRes = confirm("功能暂未开放");
    //   if (confirmRes) {
    //     this.$router.go(-1);
    //   } else {
    //     this.$router.go(-1);
    //   }
    // }
    if(window.__wxjs_environment === 'miniprogram'){
      this.showHead=1
    }else{
      this.showHead=0
    }
    this.getList(1);
    window.AG.setTitle("功能为引");
    window.scrollTo(0, 0);
    this.getHeight();
    this.overscroll(document.querySelector(".scrollwrap"));
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.addEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }
    window.AG.emH5ShareNeed(0);
    this.miniToken =
      this.$route.query.miniToken || localStorage.getItem("miniToken") || "";
    localStorage.setItem("miniToken", this.miniToken);
  },
  destroyed() {
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.removeEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }
  },
  methods: {
    // getList(page) {
    //   QueryCmsNews({ column: 1088, pageindex: this.page, pagesize: 20 }).then(
    //     res => {
    //       if (res.Success) {
    //         this.dataList = res.Result;
    //         this.isshow = true;
    //         this.page++;
    //       }
    //     }
    //   );
    // },
    getHeight() {
      this.$refs.contentbox.scrollTop = 0;
      let heightWindow = window.innerHeight;
      let heightMain;
      if(this.showHead==1){
        heightMain = heightWindow;
      }else{
        heightMain = heightWindow - 48;
      }
      // let heightMain = heightWindow - 48;
      this.$refs.contentbox.style.height = heightMain + "px";
    },
    listenScroll(evt) {
      if (!evt._isScroller) {
        evt.preventDefault();
      }
    },
    overscroll(el) {
      el.addEventListener("touchstart", function() {
        var top = el.scrollTop,
          totalScroll = el.scrollHeight,
          currentScroll = top + el.offsetHeight;
        if (top === 0) {
          el.scrollTop = 1;
        } else if (currentScroll === totalScroll) {
          el.scrollTop = top - 1;
        }
      });

      el.addEventListener("touchmove", function(evt) {
        if (el.offsetHeight < el.scrollHeight) {
          evt._isScroller = true;
        }
      });
    },
    loadingmore() {
      this.isshow = false;
      var attr = this.dataList;
      jsonp(
        "https://premium.eastmoney.com/cmsdataapi/api/CmsNews/QueryCmsNewsByColumnFile?column=1168&pageindex=" +
          this.page +
          "&pagesize=20",
        { name: "cb", param: "cb" },
        (err, data) => {
          if (err) {
            console.error(err.message);
          } else {
            if (data.Result.length != 0) {
              this.dataList = this.dataList
                .slice(0, this.dataList.length)
                .concat(data.Result);
              this.isall = false;
              this.isshow = true;
              this.page++;
            } else {
              this.isshow = false;
              this.isall = true;
            }
          }
        }
      );
    },
    jumpmore(v) {
      if (window.AG.InApp) {
        if (window.AG.ISIOS) {
          location.href =
            "eastmoney://page/newsdetail?newsid=" + v + "&newstype=1";
        } else {
          location.href = "dfcft://newsdetail?newsid=" + v + "&newstype=1";
        }
      }else{
        location.href='https://clcharge.eastmoney.com/tghtml/TSYTest/index_ol.html?id='+v
      }
    },
    getList(page) {
      jsonp(
        "https://premium.eastmoney.com/cmsdataapi/api/CmsNews/QueryCmsNewsByColumnFile?column=1168&pageindex=" +
          page +
          "&pagesize=20",
        { name: "cb", param: "cb" },
        (err, data) => {
          if (err) {
            console.error(err.message);
          } else {
            this.dataList = data.Result;
            this.isshow = true;
            this.page++;
          }
        }
      );
    }
  }
};
</script>
<style scoped>
.header {
  width: 7.5rem;
  height: 2.33rem;
  background: url(../../../public/images/introduce/bj01.png) no-repeat top
    center;
  background-size: 7.5rem 2.33rem;
}
.scrollwrap {
  overflow: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.main {
  width: 7.5rem;
}
.main li {
  width: 7rem;
  margin: 0.21rem 0.28rem 0.21rem 0.21rem;
  border-bottom: 1px solid #efefef;
}
.main_title {
  line-height: 0.68rem;
  font-size: 0.35rem;
  color: #333333;
  text-align: left;
}
.main_content {
  height: 1.13rem;
  line-height: 0.38rem;
  color: #666666;
  font-size: 0.25rem;
  text-align: left;
  overflow: hidden;
}
.main_more {
  width: 7rem;
  height: 0.36rem;
  line-height: 0.36rem;
  font-size: 0.25rem;
  color: #0000ff;
  text-align: right;
  margin: 0.3rem 0 0.38rem;
}
.main_info {
  width: 7rem;
  height: 0.36rem;
  margin: 0.24rem 0;
}
.main_date {
  float: left;
  line-height: 0.36rem;
  height: 0.36rem;
  font-size: 0.25rem;
  color: #333333;
}
.main_people {
  float: right;
  line-height: 0.36rem;
  height: 0.36rem;
  font-size: 0.25rem;
}
.clickmore {
  width: 7rem;
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 0.2rem;
  text-align: center;
  margin-bottom: 0.3rem;
}
.main_reader {
  margin-right: 0.4rem;
}
</style>
